module.exports = __webpack_public_path__ + "img/6.fe378d35.png";